// extracted by mini-css-extract-plugin
export var acceptButton = "_2w-5";
export var fullContent = "_2w-4";
export var link = "_2w-6";
export var linkIcon = "_2w-7";
export var sideContent = "_2w-3";
export var sideImage = "_2w-2";
export var sideImageWrapper = "_2w-1";
export var splitLayout = "_2w-0";